import axios from "axios";
import { treesActions } from "../../../store/slices/trees";
import { workerActions } from "../../../store/slices/workers";
import { buildTeamTree } from "./utils";

export const getChannelsId = "getChannels";

const getChannels = ({ M365server, cloner_key, team, controller }) => {
  // Worker id is namespaced per team so multiple teams can resolve in
  // parallel without trampling each other.
  const id = `${getChannelsId}-${team.id}`;

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = `${M365server}mailapi/teams/${team.id}/channel`;
      const response = await axios.get(url, {
        signal: controller?.signal,
        headers: { cloner_key },
      });

      const channels = Array.isArray(response.data) ? response.data : [];

      dispatch(
        treesActions.loadTree({
          id: `teams-${team.id}`,
          tree: buildTeamTree(team, channels),
        })
      );
      dispatch(workerActions.finish({ id }));
    } catch (e) {
      if (e.code === "ERR_CANCELED") {
        dispatch(workerActions.clear(id));
        return;
      }
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};

export default getChannels;
